import { WorkerAndWorkPlaceTypesFacade } from "./WorkerAndWorkPlaceTypeFacade";

/**
 * @deprecated Replace usages with useGetQualifications and useGetWorkplaceTypes hooks
 */
const workerAndWorkPlaceTypesProvider = new WorkerAndWorkPlaceTypesFacade();

export { workerAndWorkPlaceTypesProvider };
